<template>
  <base-tile :title="$t('users.auth.title')" i18nPrefix="users" :rows="state.rows" :noDataMessage="$t('users.auth.noAuthMethods')">
    <template v-for="(row, index) in state.rows" :key="index" #[`${row.label}-value`]>
      <td class="p-2">
      
        <va-button
          v-if="row.deletable"
          color="#DC2626"
          flat
          icon="delete"
          @click="openDangerModal(row.value)" 
        />
      </td>
    </template>
  </base-tile>
  <danger-confirm-modal
    :is-open="state.showDangerModal"
    :title="$t('users.auth.deletion')"
    :message="$t('users.auth.messageModal')"
    :button-validate-message="$t('users.auth.deletion')"
    @cancel="cancelDelete"
    @validate="UnassignUserAuth"
  />
</template>

<script setup>
import { computed, reactive, watch, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import BaseTile from '@/components/BaseTile.vue';
import DangerConfirmModal from "@/components/modal/DangerConfirmModal.vue";
import { callFetchUserAuthMethods, callDeleteUserAuth } from '@/api/identity';

const toasts = inject("toasts");
const handleError = inject("handleError");
const { t } = useI18n();
const store = useStore();

const state = reactive({
  authMethods: [],
  showDangerModal: false,
  deletableAuthID: null,
  rows: computed(() => {
    return state.authMethods.map(authMethod => ({
      label: t(`users.auth.${authMethod.type.toLowerCase()}`),
      value: authMethod.id,
      deletable: authMethod.deletable
    }));
  }),
});

const userId = computed(() => store.state.identity.user?.id);

const openDangerModal = (id) => {
  state.deletableAuthID = id
  state.showDangerModal = true;
};
const cancelDelete = () => {
  state.showDangerModal = false;
};

const fetchUserAuthMethods = async userIdentifier => {
  if (!userIdentifier) {
    state.authMethods = [];
    return;
  }

  try {
    const response = await callFetchUserAuthMethods(userIdentifier);
    state.authMethods = response.data.items;
  } catch (error) {
    handleError?.(error?.response?.data || error);
  }
};

// Unassign user authentication method
const UnassignUserAuth = async () => {
  try {
    const authMethodId = state.deletableAuthID ;
    const currentUserId = userId.value;
    if (!currentUserId) {
      return;
    }
    await callDeleteUserAuth(currentUserId, authMethodId);
    // Remove the auth method from the state after successful deletion
    
    state.authMethods = state.authMethods.filter(method => method.id !== authMethodId);
    state.showDangerModal = false;
    toasts.info(t(`users.auth.authDeleteingSucess`));
  } catch (error) {
    state.showDangerModal = true;
    handleError?.(error?.response?.data || error);
  }
};

watch(
  userId,
  async newUserId => {
    await fetchUserAuthMethods(newUserId);
  },
  { immediate: true }
);
</script>

<style scoped>
.auth-method {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.no-auth-methods {
  padding: 1rem;
  font-weight: bold;
  color: #dc2626;
}
</style>
